import _regeneratorRuntime from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import dayjs from 'dayjs';
export default {
  name: 'mng_role',
  data: function data() {
    return {
      pageConfig: {
        editPageName: '角色',
        addFunName: 'mngRoleAdd',
        modifyFunName: 'mngRoleModify',
        delFunName: 'mngRoleDel',
        queryFunName: 'mngRoleQuery',
        detailFunName: 'mngRoleDetail',
        disableFunName: 'mngRoleDisable',
        unDisableFunName: 'mngRoleUnDisable',
        menuTreeFunName: 'mngMenuTree',
        roleMenusTreeFunName: 'mngRolesMenusTree'
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        sortField: 'create_time'
      },
      formData: {
        id: null,
        name: null,
        code: null,
        image: null,
        disableState: false,
        remark: null,
        menuIds: null
      },
      menuData: {
        menuTree: [],
        roleMenuIds: null,
        menuTreeProps: {
          children: 'lowerMenus',
          label: 'name'
        }
      },
      rules: {
        name: [{
          required: true,
          message: '角色名不能为空',
          trigger: 'blur'
        }, {
          validator: 'checkAgainName',
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '角色代码不能为空',
          trigger: 'blur'
        }, {
          word: true,
          message: '只能输入数字、字母、下划线',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '100px',
      emptyFormData: {},
      emptyMenuData: {}
    };
  },
  mounted: function mounted() {
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.emptyMenuData = JSON.parse(JSON.stringify(this.menuData));
    this.query();
  },
  methods: {
    treeLoad: function treeLoad() {
      var _this = this;
      this.$api[this.pageConfig.menuTreeFunName]().then(function (res) {
        _this.menuData.menuTree = res.data;
      });
    },
    disable: function disable(id) {
      var _this2 = this;
      this.$api[this.pageConfig.disableFunName](id).then(function (res) {
        if (res.data) {
          _this2.$message.success('禁用成功');
          _this2.query();
        } else {
          _this2.$message.error('禁用失败');
        }
      });
    },
    unDisable: function unDisable(id) {
      var _this3 = this;
      this.$api[this.pageConfig.unDisableFunName](id).then(function (res) {
        if (res.data) {
          _this3.$message.success('解禁成功');
          _this3.query();
        } else {
          _this3.$message.error('解禁失败');
        }
      });
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      saveFormData.menuIds = this.$refs.menuTreeRef.getCheckedKeys().concat(this.$refs.menuTreeRef.getHalfCheckedKeys());
      return saveFormData;
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      if (!isImage) {
        this.$message.error('文件必须是图片格式');
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不超过5M！');
      }
      return isImage && isLt5M;
    },
    upload: function upload(_ref) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref.file;
              _this4.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this4.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this4.formData.image = _context.sent;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    previewFile: function previewFile() {
      window.open(this.formData.image);
    },
    removeFile: function removeFile() {
      this.formData.image = '';
    },
    add: function add() {
      this.treeLoad();
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    edit: function edit(id) {
      var _this5 = this;
      this.treeLoad();
      this.$api[this.pageConfig.roleMenusTreeFunName](id).then(function (res) {
        _this5.menuData.roleMenuIds = _this5.flatAndGetIdByTree(res.data);
      });
      this.$api[this.pageConfig.detailFunName](id).then(function (res) {
        _this5.initFormData(res.data);
        _this5.editDialogTitle = _this5.pageConfig.editPageName + '维护';
        _this5.editDialogShow = true;
      });
    },
    flatAndGetIdByTree: function flatAndGetIdByTree(menuTreeParam) {
      var menuIds = [];
      for (var i = 0; i < menuTreeParam.length; i++) {
        var menu = menuTreeParam[i];
        if (menu.lowerMenus.length > 0) {
          menuIds = menuIds.concat(this.flatAndGetIdByTree(menu.lowerMenus));
        } else {
          menuIds.push(menu.id);
        }
      }
      return menuIds;
    },
    del: function del(id) {
      var _this6 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this6.$api[_this6.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this6.$message.success('删除成功');
            _this6.query();
          } else {
            _this6.$message.error('删除失败');
          }
        });
      });
    },
    query: function query() {
      var _this7 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this7.tableData = res.data || [];
        _this7.totalCount = res.count;
        _this7.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this8 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this8.formData.id) {
            _this8.$api[_this8.pageConfig.modifyFunName](_this8.saveFormDataProcess(_this8.formData)).then(function (res) {
              if (res.data) {
                _this8.$message.success('编辑成功');
                _this8.initFormData(_this8.emptyFormData);
                _this8.menuData = _this8.emptyMenuData;
                _this8.editDialogShow = false;
                _this8.query();
              } else {
                _this8.$message.error('编辑失败');
              }
            });
          } else {
            _this8.$api[_this8.pageConfig.addFunName](_this8.saveFormDataProcess(_this8.formData)).then(function (res) {
              if (res.data) {
                _this8.$message.success('新增成功');
                _this8.initFormData(_this8.emptyFormData);
                _this8.menuData = _this8.emptyMenuData;
                _this8.editDialogShow = false;
                _this8.query();
              } else {
                _this8.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
      this.menuData = this.emptyMenuData;
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};